import { validateLocationChanged } from '../tracking/location.tracking';
import { validateSearchCompleted } from '../tracking/search.tracking';
import { WINDOW_AVAILABLE } from '../redux/app';
import { ROUTER_LOCATION_CHANGED } from '../redux/route';
import { SEARCH_COMPLETED } from '../redux/search';

let validators = {};

validators[WINDOW_AVAILABLE] = validateLocationChanged;
validators[ROUTER_LOCATION_CHANGED] = validateLocationChanged;
validators[SEARCH_COMPLETED] = validateSearchCompleted;

export default validators;
